import { ROTULO_DA_ABRANGENCIA_DO_PROCEDIMENTO, type ItemDaBaseEntrada } from "@bookdental/schemas";
import { cn } from "@/lib/cn";
import { SeletorDeChips } from "../SeletorDeChips";
import { Campo, entradaCls, type OpcoesDaBase } from "./comum";

type Procedimento = Extract<ItemDaBaseEntrada, { tipo: "procedimentos" }>;
type Especialidade = Extract<ItemDaBaseEntrada, { tipo: "especialidades" }>;

export function CamposProcedimento({ item, mudar, opcoes }: { item: Procedimento; mudar: (p: Partial<Procedimento>) => void; opcoes: OpcoesDaBase }) {
  return (
    <>
      <Campo rotulo="Nome">
        <input value={item.nome} onChange={(e) => mudar({ nome: e.target.value })} className={entradaCls} />
      </Campo>
      <Campo rotulo="Especialidade principal" dica="Agrupa o procedimento nas telas da clínica. Entra também nas especialidades abaixo.">
        <select value={item.especialidadeId} onChange={(e) => mudar({ especialidadeId: e.target.value })} className={entradaCls}>
          <option value="">Escolha a especialidade</option>
          {opcoes.especialidades.map((e) => (
            <option key={e.id} value={e.id}>
              {e.label}
            </option>
          ))}
        </select>
      </Campo>
      <Campo rotulo="Cobrança">
        <div className="flex flex-wrap gap-1">
          {Object.entries(ROTULO_DA_ABRANGENCIA_DO_PROCEDIMENTO).map(([k, v]) => (
            <button
              key={k}
              type="button"
              onClick={() => mudar({ abrangencia: k as Procedimento["abrangencia"] })}
              aria-pressed={item.abrangencia === k}
              className={cn("rounded-md border px-3 py-1 text-sm", item.abrangencia === k ? "border-admin-900 bg-admin-900 text-white" : "border-admin-200 text-admin-700 hover:bg-admin-50")}
            >
              {v}
            </button>
          ))}
        </div>
      </Campo>
      <div className="grid gap-4 sm:grid-cols-4">
        <Campo rotulo="Código TUSS">
          <input value={item.codigoTuss ?? ""} onChange={(e) => mudar({ codigoTuss: e.target.value || null })} className={entradaCls} />
        </Campo>
        <Campo rotulo="Duração (min)">
          <input
            type="number"
            min={5}
            max={600}
            value={item.duracaoMinutos ?? ""}
            onChange={(e) => mudar({ duracaoMinutos: e.target.value ? Number(e.target.value) : null })}
            className={entradaCls}
          />
        </Campo>
        <Campo rotulo="Unidade" dica="Harmonização: U, ml, frasco.">
          <input value={item.unidade ?? ""} onChange={(e) => mudar({ unidade: e.target.value || null })} className={entradaCls} />
        </Campo>
        <Campo rotulo="Cor na agenda">
          <input type="color" value={item.cor ?? "#3B82F6"} onChange={(e) => mudar({ cor: e.target.value })} className="h-9 w-full cursor-pointer rounded-md border border-admin-200 bg-white px-1" />
        </Campo>
      </div>
      <Campo rotulo="Especialidades" dica="Na clínica, quem escolhe uma destas especialidades recebe o procedimento já marcado.">
        <SeletorDeChips
          opcoes={opcoes.especialidades.map((e) => ({ id: e.id, rotulo: e.label, apagada: e.status !== "PUBLICADO" }))}
          valor={item.especialidadeIds ?? []}
          onChange={(especialidadeIds) => mudar({ especialidadeIds })}
        />
      </Campo>
    </>
  );
}

export function CamposEspecialidade({ item, mudar }: { item: Especialidade; mudar: (p: Partial<Especialidade>) => void }) {
  return (
    <>
      <Campo rotulo="Nome">
        <input value={item.nome} onChange={(e) => mudar({ nome: e.target.value })} className={entradaCls} />
      </Campo>
      <label className="flex items-center gap-2 text-sm text-admin-900">
        <input type="checkbox" checked={item.destaque} onChange={(e) => mudar({ destaque: e.target.checked })} className="accent-admin-900" />
        Em destaque no onboarding da clínica
      </label>
    </>
  );
}
